// src/api/xoe/XoeSettingsApi.ts
/**
 * @file Clinic Xoe tool-permission settings API (P5.2).
 * @module api/xoe/XoeSettingsApi
 *
 */

import { ENV } from "../../config/runtimeEnv";
import {
	XoeClinicSettings,
	XoeClinicSettingsUpdateRequest,
} from "../../types/xoe/XoeSettingsTypes";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_XOE_AGENT_SERVER;
const SETTINGS_PATH = "/practitioner/xoe/settings";

/**
 * Fetch the clinic's Xoe settings plus the tool vocabulary they are expressed in.
 */
export const fetchXoeSettings = async (): Promise<XoeClinicSettings> => {
	const response = await http.get(`${API_BASE_URL}${SETTINGS_PATH}`);
	return response.data.data;
};

/**
 * Save the clinic's Xoe settings.
 */
export const updateXoeSettings = async (
	settings: XoeClinicSettingsUpdateRequest
): Promise<XoeClinicSettings> => {
	const response = await http.put(`${API_BASE_URL}${SETTINGS_PATH}`, settings);
	return response.data.data;
};

/**
 * Clear BOTH deny-lists — tools and actions.
 */
export const resetXoeSettings = async (): Promise<XoeClinicSettings> => {
	const response = await http.post(
		`${API_BASE_URL}${SETTINGS_PATH}/reset`,
		{}
	);
	return response.data.data;
};
